export default "__VITE_ASSET__hARuizmR__"